import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types';

export type StarfishGatewayDeviceDetails = PromiseType<ReturnType<typeof DeviceManager.getStarfishDeviceDetails>>;
type ContextState = Data<StarfishGatewayDeviceDetails>;
const Context = React.createContext<ContextState | null>(null);

function useStarfishDeviceDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useStarfishGatewayDeviceDetails must be used within a StarfishDeviceDetailsProvider');
    }
    return contextState;
}

const StarfishGatewayDeviceDetailsProvider: React.FC<{ deviceId: string}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'starfish-gateway-device-details',
        id: props.deviceId,
        dataFn: React.useCallback(() => DeviceManager.getStarfishDeviceDetails(authHelper, props.deviceId), [
            authHelper,
            props.deviceId
        ]),
    });

    const deviceDetailsData = dataFromDataset(dataset);

    return <Context.Provider value={deviceDetailsData}>{props.children}</Context.Provider>;
};

const TestDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { StarfishGatewayDeviceDetailsProvider, TestDeviceDataProvider, useStarfishDeviceDetails };
